import { Interactions, LoggedInState } from '@chegg/pricing-sdk';
import { Component, fireStatusUpdate, StatusTypes, ErrorType, Namespace, ProductType as CheckoutSDKProductType, SharedCommandNames, Environment } from '@chegg/commerce-utils';
import { ProductType as PricingSDKProductType } from '@chegg/pricing-sdk';
import { getLangPreferenceCookie } from '@chegg/utils';
import { sendNewRelicError } from '../../utils/NewRelicUtils';
import { INELIGIBLE_UPGRADE_PRODUCTS } from '../../constants/appConstants';
import { getOrderManagement } from '../../lib/Graphql/getOrderManagement';
import { getCartCheckout } from '../../lib/Graphql/getCartCheckout';
import { ProductActionMap } from './interfaces';
import { HARD_LOGIN_FAILURE, NOT_ELIGIBLE } from './constants';
import * as Helpers from './helpers';
import { CART_CHECKOUT_QUERYNAME, ORDER_MANAGEMENT_QUERYNAME } from '../../constants/graphql';
var toActionMappedProduct = function toActionMappedProduct(productType) {
  var productTypeString = CheckoutSDKProductType[productType];
  return ProductActionMap[productTypeString];
};
var toQueryParamProductType = function toQueryParamProductType(productType) {
  return toActionMappedProduct(productType) || productType;
};

/**
 *  Returns GraphQl query for fetching the relevant Order Management or Cart Checkout data.
 */
export var determineContentToFetch = function determineContentToFetch(_ref) {
  var _window$location$sear;
  var productType = _ref.productType,
    action = _ref.action,
    orderManagementAction = _ref.orderManagementAction,
    cartCheckoutAction = _ref.cartCheckoutAction,
    country = _ref.country;
  var getQueryParams = {
    productType: toQueryParamProductType(productType),
    action: action,
    country: country,
    previewMode:
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    ((_window$location$sear = window.location.search) === null || _window$location$sear === void 0 ? void 0 : _window$location$sear.includes('previewMode=true').toString()) || 'false',
    locale: getLangPreferenceCookie() || 'en'
  };
  var orderManagementQuery = getOrderManagement(getQueryParams);
  var cartCheckoutQuery = getCartCheckout(getQueryParams);
  if (orderManagementAction) {
    return {
      gql: orderManagementQuery,
      queryName: ORDER_MANAGEMENT_QUERYNAME
    };
  } else if (cartCheckoutAction) {
    return {
      gql: cartCheckoutQuery,
      queryName: CART_CHECKOUT_QUERYNAME
    };
  } else {
    return {
      gql: '',
      queryName: ''
    };
  }
};

/**
 *  Determines if One Click should be rendered based on product eligibility and login state.
 */
export var shouldRenderOneClick = function shouldRenderOneClick(pricingDetails) {
  var data = pricingDetails.data;
  if (!data || !data.payload ||
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  !data.payload.eligibility ||
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  !data.payload.eligibility.eligibility) return false;
  var _data$payload$eligibi = data.payload.eligibility,
    eligibility = _data$payload$eligibi.eligibility,
    productFamily = _data$payload$eligibi.productFamily;
  var eligible = eligibility.eligible,
    existingProducts = eligibility.existingProducts;
  var hasUpgradeIneligibleProducts = productFamily == PricingSDKProductType.CHEGG_STUDY_PACK && !Helpers.canUpgrade(existingProducts);
  var interactionNotOneClick = ![Interactions.DCO_1_CLICK, Interactions.DCO_1_CLICK_NO_PRIOR_ORDER].includes(data.action);
  if (!eligible && hasUpgradeIneligibleProducts || interactionNotOneClick) {
    sendInitializationErrorStatusUpdate({
      message: NOT_ELIGIBLE,
      type: ErrorType.SERVER
    });
    sendNewRelicError(NOT_ELIGIBLE);
    return false;
  }
  if (data.loginState !== LoggedInState.HARD) {
    sendInitializationErrorStatusUpdate({
      message: HARD_LOGIN_FAILURE,
      type: ErrorType.AUTHORIZATION
    });
    return false;
  }
  return true;
};

/**
 *  Informs the client of errors encountered during initialization.
 */
var sendInitializationErrorStatusUpdate = function sendInitializationErrorStatusUpdate(error) {
  fireStatusUpdate([{
    status: StatusTypes.ERROR,
    command: SharedCommandNames.INITIALIZE,
    payload: {
      component: Component.ONE_CLICK,
      errors: [error]
    }
  }], Namespace.ONE_CLICK);
};

/**
 *  Determines if a user's existing products makes them ineligible for upgrade.
 */
export var canUpgrade = function canUpgrade(existingProducts) {
  if (!existingProducts) return true;
  return !existingProducts.some(function (_ref2) {
    var itemId = _ref2.itemId;
    return INELIGIBLE_UPGRADE_PRODUCTS.includes(itemId);
  });
};

/**
 * Ensures that the `environment` string is a member of the Environment enum
 */
export var getEnvironment = function getEnvironment(environment) {
  if (environment == 'prod') return Environment.PRODUCTION;
  if (environment == 'stage') return Environment.STAGING;
  return environment;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/OneClick/helpers.js
// module id = 1540
// module chunks = 11